import type {
  OverlayEntry,
  OverlayRegistrationProps,
} from '@/app/components/overlays/core/types';
import { getOverlayRegistryKey } from '@/app/components/overlays/utils/getOverlayRegistryKey';

/**
 * A central registry that tracks all active overlays and their lifecycle actions.
 */
export const overlayRegistry = {
  map: new Map<string, OverlayEntry>(),
  openQueue: new Set<string>(),
  toggleQueue: new Set<string>(),
};

/**
 * Registers an overlay entry into the global registry.
 *
 * @param props - Includes overlayKey and optional instanceId for uniqueness
 * @param entry - Lifecycle methods (open, isOpen) for the overlay instance
 */
export const registerOverlay = (
  props: OverlayRegistrationProps,
  entry: OverlayEntry
): void => {
  const key = getOverlayRegistryKey(props);
  overlayRegistry.map.set(key, entry);
};

/**
 * Unregisters an overlay entry from the global registry.
 *
 * @param props - Overlay identifier (key + optional instanceId)
 */
export const unregisterOverlay = (props: OverlayRegistrationProps): void => {
  const key = getOverlayRegistryKey(props);
  overlayRegistry.map.delete(key);
};
